<template>
    <div class="mb-2">
        <label style="width:60px">{{ customizeTable.labelShowing }}
            <select @change="$emit('makeSelected', item)" class="form-control" v-model="item">
                <option v-for="(entrie, key) in customizeTable.entries" :key="key" :value="entrie">{{ entrie }}</option>
            </select> {{ customizeTable.labelEntries }}
        </label>
    </div>
</template>

<script>
    export default {
        name: "withPerPage",
        data: (vm) => ({
            item: vm.customizeTable.entries[0]
        }),
        props: {
            customizeTable: {
                type: Object,
                default: () => {}
            }
        }
    }
</script>

<style scoped>

</style>
